import type { MouseEvent } from "react";

/** Matches `scroll-padding-top` in index.css, so both paths land identically. */
const SCROLL_OFFSET = 96;

/**
 * Scrolls to an in-page section without pushing its id onto the URL, keeping
 * the address bar on the bare domain. Returns false when the target is
 * missing so the caller can fall back to the browser's own anchor handling.
 */
export function scrollToSection(
  href: string,
  behavior: ScrollBehavior = "smooth",
): boolean {
  if (!href.startsWith("#")) return false;

  const target = document.getElementById(href.slice(1));
  if (!target) return false;

  window.scrollTo({
    top: Math.max(target.offsetTop - SCROLL_OFFSET, 0),
    behavior,
  });
  return true;
}

/** Click handler for any anchor pointing at a section on this page. */
export function handleSectionLink(
  event: MouseEvent<HTMLAnchorElement>,
  href: string,
) {
  if (scrollToSection(href)) event.preventDefault();
}
